import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IMergeProgress } from '../interfaces/duplikit-interfaces';
import { UtilsService } from './utils.service';

@Injectable()
export class DuplikitMergeService {
  mergeCheckTimer: Subscription;
  mergeCheck: IMergeProgress;

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService
  ) {
  }

  runMergeCheck() {
    if (this.mergeCheckTimer) {
      this.mergeCheckTimer.unsubscribe();
    }

    this.mergeCheckTimer = timer(0, 60000).subscribe(() => {
      this.getMergeCheck().subscribe((res) => {
        this.mergeCheck = res;
      });
    });
  }

  stopMergeCheck(): void {
    if (this.mergeCheckTimer) {
      this.mergeCheckTimer.unsubscribe();
    }
  }

  getMergeCheck(): Observable<any> {
    return this.http.get<boolean>(`${environment.duplikitUrl}/DedupeTask/corpIsMerging`);
  }

  entityIsMerging(entity: string = null): boolean {
    if (!this.mergeCheck) {
      return false;
    }

    if (!entity) {
      return this.mergeCheck.isMerging;
    }

    return this.mergeCheck.entityProgress.find((e) => e.entity === entity).isMerging;
  }

  setEntityIsMerging(entity: string): void {
    this.mergeCheck.isMerging = true;
    this.mergeCheck.entityProgress.find(
      (e) => e.entity === this.utilsService.getProperEntityName(entity)
    ).isMerging = true;
  }

  anyEntityIsMerging(): boolean {
    if (!this.mergeCheck)
      return false;

    return this.mergeCheck.isMerging;
  }

  getEntityThatIsMerging(): string {
    if (this.entityIsMerging('Candidate'))
      return 'Candidate';
    else if (this.entityIsMerging('ClientContact'))
      return 'ClientContact';
    else if (this.entityIsMerging('ClientCorporation'))
      return 'ClientCorporation';
  }
}
